var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_800_6176)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_800_6176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#DFE0E2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_800_6176)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#E0E3E1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.3889,
    stroke: "#171E26",
    strokeOpacity: 0.2,
    strokeWidth: 1.22222
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 23.5907V22.4902C4.66699 18.384 7.29112 15.0557 10.5281 15.0557H13.4725C16.7095 15.0557 19.3337 18.384 19.3337 22.4902V23.5907H4.66699Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9042 4.66699H11.0966C9.23323 4.66699 7.72266 6.22925 7.72266 8.1564C7.72266 10.0835 9.23323 11.6458 11.0966 11.6458H12.9042C14.7676 11.6458 16.2782 10.0835 16.2782 8.1564C16.2782 6.22925 14.7676 4.66699 12.9042 4.66699Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 12.0012C16.0504 12.0012 19.3337 10.9067 19.3337 9.55652C19.3337 8.20635 16.0504 7.11182 12.0003 7.11182C7.95024 7.11182 4.66699 8.20635 4.66699 9.55652C4.66699 10.9067 7.95024 12.0012 12.0003 12.0012Z",
    fill: "#A9ACAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5511 9.12158H10.4497C8.71475 9.12158 8.37435 9.8055 8.36439 9.92026C8.35442 10.035 8.33398 10.6992 8.33398 10.8633V11.824C8.33398 13.9339 9.97519 15.2327 12.0006 15.2327C14.0256 15.2327 15.6673 13.9344 15.6673 11.824V10.8633C15.6673 10.7018 15.6588 10.0999 15.6369 9.92078C15.615 9.74163 15.0114 9.12158 13.5511 9.12158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.7783,
    y: 13.2227,
    width: 2.44444,
    height: 3.66667,
    rx: 1.22222,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_800_6176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.0bf1f2ec1c35be72d8e2d75e207f3e21.svg";
export { ForwardRef as ReactComponent };